import React from 'react';

export const PageComponentMainBottomBorder = () => (
  <div className="absolute -right-6 -left-6 -bottom-10 bg-brand-white lg:hidden">
    <div className="h-10 rounded-b-xl bg-background-primary-light" />
  </div>
);
